import { useSearchParams } from "react-router-dom";
import { SyncPanel } from "@/components/account/SyncPanel";
import { PrivacyPanel } from "@/components/account/PrivacyPanel";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function Account() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("onglet") || "sync";
  return (
    <div className="max-w-7xl mx-auto fade-up" data-testid="account-page">
      <p className="text-xs uppercase tracking-wider font-semibold text-slate-500">Mon compte</p>
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mt-1 mb-6">Synchronisation & confidentialité</h1>
      <Tabs value={tab} onValueChange={(v) => setParams({ onglet: v }, { replace: true })}>
        <TabsList className="mb-6">
          <TabsTrigger value="sync" data-testid="account-tab-sync">Synchronisation PC</TabsTrigger>
          <TabsTrigger value="privacy" data-testid="account-tab-privacy">Mes données (RGPD)</TabsTrigger>
        </TabsList>
        <TabsContent value="sync"><SyncPanel /></TabsContent>
        <TabsContent value="privacy"><PrivacyPanel /></TabsContent>
      </Tabs>
    </div>
  );
}
